import { RefObject, useCallback, useEffect } from 'react';
import { TableRef } from '@qsxy/element-plus-react';
import debounce from 'lodash/debounce';

/**
 * 表格自动调整高度
 * @param tableContainerRef 表格容器div
 * @param tableRef 表格实例ref
 * @param delHeight 用来计算表格的高度，此高度为表格下方内容占据高度，总高度减去此高度以及表格上方的高度（自动获取）即为表格高度
 */
export const useTableResize = (tableContainerRef: RefObject<HTMLDivElement>, tableRef: RefObject<TableRef<any>>, delHeight = 65, autoHeight?: boolean) => {
	const resizeFn = debounce(
		useCallback(() => {
			if (tableContainerRef.current) {
				const { top } = tableContainerRef.current.getBoundingClientRect();
				tableRef.current.setHeight(document.body.clientHeight - top - delHeight);
			}
		}, [delHeight, tableContainerRef, tableRef]),
		200,
	);

	useEffect(() => {
		if (autoHeight) {
			window.addEventListener('resize', resizeFn);
			resizeFn();

			return () => window.removeEventListener('resize', resizeFn);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { resizeFn };
};
